import React from 'react';
import PropTypes from 'prop-types';
import SearchGroupInput from '../input/SearchGroupInput.component';
import {MY_TASKS_DATES} from "utils/constants";
import _ from "lodash";
import { DropdownSelect } from "components/common/dropdown/DropdownSelect.component";
import { DropdownSelectTypes } from "types/gaiaComponents/dropdownButton.types";

const SearchView = (props) => {

    let sort = function (value) {
        props.changeDisplayedDate(value);
    };

    const sortingDate = _.cloneDeep(MY_TASKS_DATES);

    let dateToPick = Object.keys(sortingDate).map((key) => ({
        key,
        text: props.translate("myTasks.selectDate." + MY_TASKS_DATES[key]),
        onClick: () => sort(MY_TASKS_DATES[key]),
        selected: props.displayedDate === MY_TASKS_DATES[key]
    }));

    let chooseDateToDisplay = (
        <div className="d-flex align-items-center gap-8">
            <div className="text-nowrap">
                {props.translate("myTasks.selectDate.date")}
            </div>
            <div>
                <DropdownSelect
                    id="SelectMyTasksDate"
                    type={DropdownSelectTypes.VALUE}
                    value={props.translate("myTasks.selectDate." + props.displayedDate)}
                    items={dateToPick}
                    isEmpty={false}
                />
            </div>
        </div>
    );

    return (
        <section className="container col-md-12 px-0">
            <div className="row margin-bottom mx-0">
                <aside className="search-group col-md-2 px-0" role="search">
                    <SearchGroupInput value={props.searchValue}
                                      onInputChange={(e) => {
                                          props.updateSearchCallback(e.target.value.toLowerCase())
                                      }}
                                      onClearInput={() => {
                                          props.updateSearchCallback()
                                      }}
                                      translate={props.translate}/>
                </aside>
                <aside className="col-md-10 px-0 d-flex flex-wrap justify-content-end gap-16" aria-label={props.translate("myTasks.filterMyTasks")}>
                    {chooseDateToDisplay}
                    {!props.oneCompanyOnlyUser &&
                        <div className="ga-segmented-control"
                             aria-label={props.translate("myTasks.filterMyTasks")}>
                            <button type="button"
                                    className={"ga-segmented-control__button "+ (props.onlyCurrentCompany ? "" : " ga-segmented-control__button--selected")}
                                        onClick={() => props.updateCompanyFilterCallback(false)}
                                        data-cy="myTasks.allCompanies">
                                    {props.translate("myTasks.allCompanies")}
                                        </button>
                                        <button type="button"
                                        className={"ga-segmented-control__button " + (props.onlyCurrentCompany ? "ga-segmented-control__button--selected" : " ")}
                                    onClick={() => props.updateCompanyFilterCallback(true)}
                                    data-cy="myTasks.currentCompany">
                                {props.translate("myTasks.currentCompany")}
                            </button>
                        </div>
                    }
                </aside>
            </div>
        </section>
    );

}

export default SearchView;

SearchView.propType = {
    updateSearchCallback: PropTypes.func,
    updateCompanyFilterCallback: PropTypes.func,
    translate: PropTypes.func,
    searchValue: PropTypes.string,
    onlyCurrentCompany: PropTypes.bool,
    oneCompanyOnlyUser: PropTypes.bool,
    changeDisplayedDate: PropTypes.func,
    displayedDate: PropTypes.string
};
